import ArrowIcon from "./arrow.svg?react";
import CalendarIcon from "./calendar.svg?react";
import { CalendarPlusIcon } from "./calendar-plus";
import CheckIcon from "./check.svg?react";
import ClockIcon from "./clock.svg?react";
import CloseIcon from "./close.svg?react";
import CommentBubbleIcon from "./commentBubble.svg?react";
import CopyIcon from "./copy.svg?react";
import CycleIcon from "./cycle.svg?react";
import EnvelopeIcon from "./envelope.svg?react";
import ExclamationIcon from "./exclamation.svg?react";
import InfoIcon from "./info.svg?react";
import MailIcon from "./mail.svg?react";
import MapIcon from "./map.svg?react";
import PencilIcon from "./pencil.svg?react";
import PhoneIcon from "./phone.svg?react";
import RestoreIcon from "./restore.svg?react";

export default function Icon({
  name,
  ...props
}: {
  name:
    | "arrow"
    | "calendar"
    | "calendar-plus"
    | "check"
    | "clock"
    | "close"
    | "commentBubble"
    | "copy"
    | "cycle"
    | "envelope"
    | "exclamation"
    | "info"
    | "mail"
    | "map"
    | "pencil"
    | "phone"
    | "restore";
} & React.ComponentPropsWithoutRef<"svg">) {
  switch (name) {
    case "arrow":
      return <ArrowIcon {...props} />;
    case "calendar":
      return <CalendarIcon {...props} />;
    case "calendar-plus":
      return <CalendarPlusIcon {...props} />;
    case "check":
      return <CheckIcon {...props} />;
    case "clock":
      return <ClockIcon {...props} />;
    case "close":
      return <CloseIcon {...props} />;
    case "commentBubble":
      return <CommentBubbleIcon {...props} />;
    case "copy":
      return <CopyIcon {...props} />;
    case "cycle":
      return <CycleIcon {...props} />;
    case "envelope":
      return <EnvelopeIcon {...props} />;
    case "exclamation":
      return <ExclamationIcon {...props} />;
    case "info":
      return <InfoIcon {...props} />;
    case "mail":
      return <MailIcon {...props} />;
    case "map":
      return <MapIcon {...props} />;
    case "pencil":
      return <PencilIcon {...props} />;
    case "phone":
      return <PhoneIcon {...props} />;
    case "restore":
      return <RestoreIcon {...props} />;
  }
}
